import React from 'react';
import DayPicker, {DateUtils} from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import moment from 'moment'
import 'moment/locale/pl';
import 'moment/locale/en-gb';
import 'moment/locale/de';
import 'moment/locale/ru';
import PropTypes from "prop-types"
import {getBookingEngineTranslations} from '../../functions/helpers';

import '@assets/sass/components/calendar.scss';

import {
    convertStringsToDates,
    getCurrentMonthPastDays
} from './Api/Avaibility';

import StayDate from "./StayDate";

class Calendar extends React.Component {
    state = {
        from: null,
        to: null,
        locale: 'pl',
        numberOfMonths: 1,
        disabledDays: null,
        enteredTo: null,
        post_id: null,
        avaibility: null,
        tempNewDate: {
            from: null,
            to: null
        },
        numberOfDaysToCheck: 50,
        initialDateSet: false,
    }

    componentDidMount = () => {
        this.setInitialDate()
        this.setLocale()
    }

    componentDidUpdate(prevProps, prevState) {
        const isDateInherited = this.props.date.from && this.props.date.to
        const currentDateFrom = this.state.from ? this.state.from.toISOString().substring(0, 10) : null
        const currentDateTo = this.state.to ? this.state.to.toISOString().substring(0, 10) : null
        const tempFrom = this.state.tempNewDate.from !== null ? this.state.tempNewDate.from : null
        const tempTo = this.state.tempNewDate.to !== null ? this.state.tempNewDate.to : null

        if (this.props.daysOccupied !== null && !this.state.disabledDays) this.disableDays()

        if (!isDateInherited) {
            this.setDate()
        } else {
            if (!tempFrom && !tempTo && !this.state.dateUpdated) {
                this.updateDate()
            }

            if ((currentDateFrom !== tempFrom) && (currentDateTo !== tempTo) && currentDateTo) {
                this.setDate()
            }
        }
    }

    setLocale = () => {
        const {locale} = this.props

        if (locale === 'en') {
            this.setState({
                locale: 'en-gb'
            })
        } else {
            this.setState({locale})
        }
    }

    setDate = () => {
        const {from, to} = this.state
        const {onDateSelected} = this.props;
        const currentDateFrom = from ? from.toISOString().substring(0, 10) : null
        const currentDateTo = to ? to.toISOString().substring(0, 10) : null
        const tempFrom = this.state.tempNewDate ? this.state.tempNewDate.from : null
        const tempTo = this.state.tempNewDate ? this.state.tempNewDate.to : null

        if (
            !from ||
            !to ||
            (tempFrom === currentDateFrom) ||
            (tempTo === currentDateTo)
        ) return

        onDateSelected(true)

        this.setState({
            tempNewDate: {
                from: currentDateFrom,
                to: currentDateTo
            }
        })
    }

    setInitialDate = () => {
        const {date, date: {from, to}, post_id, onDateSelected} = this.props
        const dateFrom = from ? new Date(from) : null
        const dateTo = to ? new Date(to) : null

        this.setState({
            from: dateFrom,
            to: dateTo,
            enteredTo: dateTo,
            post_id,
            initialDate: date,
            tempNewDate: {
                from: from,
                to: to
            },
        }, () => {
            this.disableDays()
            onDateSelected(true)
        })
    }

    updateDate = () => {
        const {date, date: {from, to}, post_id, onDateSelected} = this.props
        const dateFrom = from ? new Date(from) : null
        const dateTo = to ? new Date(to) : null

        this.setState({
            from: dateFrom,
            to: dateTo,
            enteredTo: dateTo,
            post_id,
            initialDate: date,
            tempNewDate: {
                from: from,
                to: to
            },
            dateUpdated: true
        }, () => {
            this.disableDays()
            onDateSelected(true)
        })
    }

    disableDays = () => {
        const {daysOccupied} = this.props
        if (!daysOccupied) return
        const {to} = this.state

        const dateTo = to ? to.setHours(12) : null;
        const occupiedDaysConverted = convertStringsToDates(daysOccupied);
        const occupiedDays = dateTo ? occupiedDaysConverted.filter(date => +date !== +dateTo) : occupiedDaysConverted
        const currentMonthPastDays = getCurrentMonthPastDays(new Date());
        const disabled_days = [...occupiedDays, ...currentMonthPastDays]

        this.setState({
            disabledDays: disabled_days,
            defaultDisabled: disabled_days,
        });
    }

    isSelectingFirstDay = (from, to, day) => {
        const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
        const isRangeSelected = from && to;
        return !from || isBeforeFirstDay || isRangeSelected;
    }

    addDaysToDate = (date, days) => {
        let result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    subtractDaysFromDate = (date, days) => {
        let result = new Date(date);
        result.setDate(result.getDate() - days);
        return result;
    }

    handleDaySelection = selectedDay => {
        const {from, to} = this.state;

        if (from && to && selectedDay >= from && selectedDay <= to) {
            this.handleCleanDate();
            return;
        }

        let nextOccupiedDay

        if (this.isSelectingFirstDay(from, to, selectedDay)) {
            const isSelectedDayValid = this.validateCheckInDate(selectedDay)
            if (!isSelectedDayValid) return

            nextOccupiedDay = this.getNextOccupiedDay(selectedDay);
            const disabledDaysInitial = this.getDisabledDaysInitial(this.state.disabledDays)
            const disabledDaysBeforeSelectedDay = this.getDisabledDaysBeforeSelectedDay(selectedDay)
            const disabledDaysAfterFirstOccupiedDay = this.getDisableDaysAfterNextOccupiedDay(nextOccupiedDay)
            const disabledDays = [
                // ...this.state.defaultDisabled,
                ...disabledDaysInitial,
                ...disabledDaysBeforeSelectedDay,
                ...disabledDaysAfterFirstOccupiedDay
            ]
            const disabledDaysWithNextDayEnabled = this.getDisabledDaysWithBookingDateAndNextDayAfterEnabled(disabledDays, selectedDay, nextOccupiedDay)

            this.setState({
                disabledDays: disabledDaysWithNextDayEnabled,
                from: selectedDay,
                to: null,
                enteredTo: null,
            })

        } else {
            nextOccupiedDay = this.getNextOccupiedDay(this.state.from);
            const isSelectedDayValid = this.validateCheckOutDate(selectedDay, nextOccupiedDay)
            if (!isSelectedDayValid) return

            this.setState({
                to: selectedDay,
                enteredTo: selectedDay,
            });
        }
    }

    validateCheckInDate = selectedDay => {
        const {disabledDays, from} = this.state
        const isSelectedDayDisabled = disabledDays.filter(disabledDay => +disabledDay === +selectedDay).length
        const isSelectedRangeBiggerThanLimit = from && (moment(selectedDay).diff(from, 'days') >= this.state.numberOfDaysToCheck)
        const isTheSameDate = +selectedDay === +from

        return !(isSelectedDayDisabled || isSelectedRangeBiggerThanLimit || isTheSameDate);
    }

    validateCheckOutDate = (selectedDay, nextOccupiedDay) => {
        const {disabledDays, from} = this.state
        const followingDisabledDay = this.addDaysToDate(nextOccupiedDay, 1)
        const isSelectedDayDisabled = disabledDays.filter(disabledDay => +disabledDay === +selectedDay && +selectedDay === +followingDisabledDay).length
        const isSelectedRangeBiggerThanLimit = from && (moment(selectedDay).diff(from, 'days') >= this.state.numberOfDaysToCheck)
        const isTheSameDate = +selectedDay === +from

        return !(isSelectedDayDisabled || isSelectedRangeBiggerThanLimit || isTheSameDate);
    }

    getNextOccupiedDay = selectedDay => {
        for (let i = 0; i <= this.state.numberOfDaysToCheck; i++) {
            let followingDay = this.addDaysToDate(selectedDay, i);
            const dateOccupied = this.state.disabledDays.map(Number).includes(+followingDay);

            if (dateOccupied && i) {
                return followingDay;
            }
        }
    }

    getDisabledDaysInitial = initialDisabledDays => {
        return initialDisabledDays.map(date => {
            if (date instanceof Date) {
                return date.setHours(12)
            } else {
                return new Date(date).setHours(12)
            }
        })
    }

    getDisabledDaysBeforeSelectedDay = selectedDay => {
        const disabledDays = [];

        for (let i = 1; i <= this.state.numberOfDaysToCheck; i++) {
            let previousDay = this.subtractDaysFromDate(selectedDay, i)
            disabledDays.push(previousDay)
        }

        return disabledDays
    }

    getDisableDaysAfterNextOccupiedDay = nextAvailableDay => {
        const disabledDays = [];

        for (let i = 1; i <= this.state.numberOfDaysToCheck; i++) {
            let followingDay = this.addDaysToDate(nextAvailableDay, i)
            disabledDays.push(followingDay);
        }

        return disabledDays
    }

    getDisabledDaysWithBookingDateAndNextDayAfterEnabled = (disabledDays, selectedDay, nextOccupiedDay) => {
        return disabledDays.filter(disabledDay => +disabledDay < +selectedDay || +disabledDay >= +nextOccupiedDay)
    }

    handleDayMouseEnter = (day) => {
        const {from, to} = this.state;
        if (!this.isSelectingFirstDay(from, to, day)) {
            this.setState({
                enteredTo: day,
            });
        }
    }

    handleCleanDate = () => {
        this.setState({
            from: null,
            to: null,
            enteredTo: null,
            tempNewDate: {
                from: null,
                to: null
            }
        }, () => {
            this.disableDays()
            this.props.onClear()
        })
    }

    getBookingDate = (dateType) => {
        const bookingDate = this.state[dateType]

        if (bookingDate) return bookingDate.toLocaleDateString()
        return null
    }

    render() {
        const {from, to, enteredTo, disabledDays, locale, numberOfMonths} = this.state;
        const modifiers = {start: from, end: enteredTo};
        const selectedDays = [from, {from, to: enteredTo}];
        const checkIn = this.getBookingDate('from')
        const checkOut = this.getBookingDate('to')
        const translations = getBookingEngineTranslations()

        const dayPickerDefaults = {
            className: "Range",
            localeUtils: MomentLocaleUtils,
            locale: locale,
            numberOfMonths: numberOfMonths,
            selectedDays: selectedDays,
            disabledDays: disabledDays,
            modifiers: modifiers,
            onDayClick: day => this.handleDaySelection(day),
            onDayMouseEnter: day => this.handleDayMouseEnter(day),
        }

        return (
            <div className="calendar">
                <div className="DayPicker__selected_date">
                    {checkIn ?
                        <StayDate
                            checkIn={{
                                heading: translations['checkin'],
                                date: moment(checkIn, 'D-MM-YYYY').format('DD-MM-YYYY')
                            }}
                            checkOut={{
                                heading: checkIn ? translations['checkout'] : '',
                                date: checkIn ?
                                    (
                                        checkIn && !checkOut
                                            ? translations['calendar-heading-3']
                                            : moment(checkOut, 'D-MM-YYYY').format('DD-MM-YYYY')
                                    )
                                    : ''
                            }}
                            increase={'day'}
                            separator={'dot'}
                            yearChar={'r.'}
                        >
                            <div className="stay-date__additional">
                                <button className="btn--reset_button" onClick={this.handleCleanDate}>
                                    {translations['calendar-clean-date']}
                                </button>
                                <div className="item__info item__info--bold nights-count-calendar">
                                    {this.props.nightsTotal}
                                </div>
                            </div>
                        </StayDate>
                        :
                        <div className={'DayPicker__subheading'}>{translations['calendar-heading-2']}</div>
                    }
                </div>
                {this.props.date.from ?
                    <DayPicker
                        {...dayPickerDefaults}
                        month={from ? new Date(from) : new Date()}
                        fromMonth={new Date()}
                        localeUtils={MomentLocaleUtils}
                        locale={this.state.locale}
                    /> :
                    <DayPicker
                        {...dayPickerDefaults}
                        month={new Date()}
                        initialMonth={new Date()}
                        fromMonth={new Date()}
                        localeUtils={MomentLocaleUtils}
                        locale={this.state.locale}
                    />
                }
            </div>
        );
    }
}

Calendar
    .contextTypes = {
    store: PropTypes.object,
};

export default Calendar;
